module.exports = __webpack_public_path__ + "img/Average.4eaa0611.svg";